import { config } from '../config';

/**
 * Normalize image/media URLs so the browser always loads uploaded assets
 * through the public API reverse proxy on 443.
 *
 * Handles:
 * - /uploads/...
 * - /api/uploads/...
 * - https://www.astro-vino.co.uk/uploads/...
 * - legacy high-port API upload URLs
 * - https://api.astro-vino.co.uk/api/uploads/...
 */
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '';

  let value = String(imageUrl).trim();
  if (!value) return '';

  // Decode common JSON-escaped slashes/backslashes that can appear in rich text/data files.
  value = value.split('\\/').join('/').split('\\').join('/');

  // If a full URL was supplied, keep only its pathname for Astro Vino assets.
  // This prevents https://api.astro-vino.co.uk/api/uploads/... from becoming
  // https://api.astro-vino.co.uk/api/https://api.astro-vino.co.uk/api/uploads/...
  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value);
      const host = url.hostname.toLowerCase();
      if (
        host === 'api.astro-vino.co.uk' ||
        host === 'www.astro-vino.co.uk' ||
        host === 'astro-vino.co.uk' ||
        host === 'avsiteapi.astrovinoserver.synology.me'
      ) {
        value = url.pathname;
      } else {
        return value;
      }
    } catch (error) {
      value = value.split('\\/').join('/').split('\\').join('/');
    }
  }

  if (!value.startsWith('/')) {
    value = '/' + value;
  }

  if (!value.startsWith('/api/')) {
    value = '/api' + value;
  }

  value = value.split('\\/').join('/').split('\\').join('/');

  return `${config.API_URL}${value}`;
};


export const getDerivativeImageUrl = (imageUrl, variant = 'medium') => {
  const original = getImageUrl(imageUrl);
  if (!original || !['thumb', 'medium'].includes(variant)) return original;
  try {
    const url = new URL(original);
    const marker = '/api/uploads/';
    const idx = url.pathname.indexOf(marker);
    if (idx === -1 || url.pathname.includes('/optimized/')) return original;
    const prefix = url.pathname.substring(0, idx + marker.length);
    const rest = url.pathname.substring(idx + marker.length);
    const slash = rest.lastIndexOf('/');
    const dir = slash >= 0 ? rest.substring(0, slash + 1) : '';
    const file = slash >= 0 ? rest.substring(slash + 1) : rest;
    const dot = file.lastIndexOf('.');
    const base = dot > 0 ? file.substring(0, dot) : file;
    url.pathname = `${prefix}${dir}optimized/${base}-${variant}.webp`;
    return url.toString();
  } catch (_) {
    return original;
  }
};
